var i = /* @__PURE__ */ ((r) => (r.horizontal = "horizontal", r.vertical = "vertical", r))(i || {});
function t(r) {
  const e = ["divider"];
  return r === "horizontal" ? e.push("divider-horizontal") : e.push("divider-vertical"), e.join(" ");
}
export {
  i as DividerOrientations,
  t as getDividerClasses
};
